module.exports = __webpack_public_path__ + "img/10.e6809676.png";